// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NotificationsUI_loader__NbIwN{
  display: flex;
  flex:1 1;
  justify-content: center;
  align-items: center;
}

/*modal */

.NotificationsUI_header__uEEiD{
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #cfcfcf;
  margin-bottom: 15px;
  padding-bottom: 15px;
}

.NotificationsUI_title__x-EA\\+{
  font-family: BebasNeue;
  font-size: 700;
  font-size: 20px;
  color: --var(--darkGray)
}

.NotificationsUI_datePicker__BYcNp{
  width: 225px;
}

.NotificationsUI_labelFormItem__z7SAK{
  color:var(--darkGray);
  font-size: 12px;
  font-weight: 500;
}

.NotificationsUI_submit__U-\\+z2{
  width: 225px;
  font-weight: 700;
  font-size: 12px;
}

.NotificationsUI_colPreview__ELOY2{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.NotificationsUI_container__e-qav{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 200px;
  height: 100px;
  border-radius: 30px;
  border:2px solid #ebebeb;
  border-bottom: 0px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}

.NotificationsUI_notchLighter__TuDmJ{
  display: flex;
  align-items: center;
  gap:10px;
  margin-bottom: 10px;
}

.NotificationsUI_notch__MFggP{
  width: 50px;
  height: 10px;
  border-radius: 20px;
  border:1px solid #ebebeb;
}

.NotificationsUI_lighter__BZJXm{
  width: 10px;
  height: 10px;
  border-radius: 20px;
  border:1px solid #ebebeb;
}

.NotificationsUI_notification__jieHE{
  display: flex;
  flex-direction: column;
  width: 175px;
  height: 50px;
  border: 2px solid #9b9b9b;
  overflow: hidden;
  white-space: nowrap;
}

.NotificationsUI_notification__jieHE p {
  margin: 0px;
}`, "",{"version":3,"sources":["webpack://./src/pages/notifications/styles/NotificationsUI.module.css"],"names":[],"mappings":"AAEA;EACI,aAAa;EACb,QAAM;EACN,uBAAuB;EACvB,mBAAmB;AACvB;;AACA,SAAS;;AACT;EACC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;AAErB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf;AACF;;AAEA;EACI,YAAY;AAChB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACI,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACnB;;AAEA;EACI,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AAC3B;;AACA;EACI,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,8BAA8B;EAC9B,+BAA+B;AACnC;;AACA;EACI,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACvB;;AACA;EACI,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;AAC5B;;AAEA;EACI,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;AAC5B;;AAEA;EACI,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACvB;;AACA;EACI,WAAW;AACf","sourcesContent":["\n\n.loader{\n    display: flex;\n    flex:1;\n    justify-content: center;\n    align-items: center;\n}\n/*modal */\n.header{\n display: flex;\n justify-content: space-between;\n align-items: center;\n border-bottom: 1px solid #cfcfcf;\n margin-bottom: 15px;\n padding-bottom: 15px;\n\n}\n\n.title{\n  font-family: BebasNeue;\n  font-size: 700;\n  font-size: 20px;\n  color: --var(--darkGray)\n}\n\n.datePicker{\n    width: 225px;\n}\n\n.labelFormItem{\n  color:var(--darkGray);\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.submit{\n    width: 225px;\n    font-weight: 700;\n    font-size: 12px;\n}\n\n.colPreview{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n.container{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    width: 200px;\n    height: 100px;\n    border-radius: 30px;\n    border:2px solid #ebebeb;\n    border-bottom: 0px;\n    border-bottom-left-radius: 0px;\n    border-bottom-right-radius: 0px;\n}\n.notchLighter{\n    display: flex;\n    align-items: center;\n    gap:10px;\n    margin-bottom: 10px;\n}\n.notch{\n    width: 50px;\n    height: 10px;\n    border-radius: 20px;\n    border:1px solid #ebebeb;\n}\n\n.lighter{\n    width: 10px;\n    height: 10px;\n    border-radius: 20px;\n    border:1px solid #ebebeb;\n}\n\n.notification{\n    display: flex;\n    flex-direction: column;\n    width: 175px;\n    height: 50px;\n    border: 2px solid #9b9b9b;\n    overflow: hidden;\n    white-space: nowrap;\n}\n.notification p {\n    margin: 0px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loader": `NotificationsUI_loader__NbIwN`,
	"header": `NotificationsUI_header__uEEiD`,
	"title": `NotificationsUI_title__x-EA+`,
	"datePicker": `NotificationsUI_datePicker__BYcNp`,
	"labelFormItem": `NotificationsUI_labelFormItem__z7SAK`,
	"submit": `NotificationsUI_submit__U-+z2`,
	"colPreview": `NotificationsUI_colPreview__ELOY2`,
	"container": `NotificationsUI_container__e-qav`,
	"notchLighter": `NotificationsUI_notchLighter__TuDmJ`,
	"notch": `NotificationsUI_notch__MFggP`,
	"lighter": `NotificationsUI_lighter__BZJXm`,
	"notification": `NotificationsUI_notification__jieHE`
};
export default ___CSS_LOADER_EXPORT___;
